package feature.auth.event

class AuthEvent {
    companion object {
        const val AUTHENTICATE = "AUTHENTICATE"
        const val AUTHENTICATE_USER = "AUHTENTICATE_USER"
        const val LOGIN = "LOGIN"
        const val REGISTER = "REGISTER"
        const val UPDATE_PROFILE = "UPDATE_PROFILE"
        const val SEND_OTP = "SEND_OTP"
        const val CHECK_ACCOUNT = "CHECK_ACCOUNT"
        const val SET_PASSWORD = "SET_PASSWORD"
        const val UPDATE_FCM_TOKEN = "UPDATE_FCM_TOKEN"
        const val RETRIEVE_ALL_LANGUAGE = "RETRIEVE_ALL_LANGUAGE"
    }
}